import { NewsBriefingProvider } from './_context/NewsContext';
import { NewsBriefingSwiper } from './NewsBriefingSwiper';
import { useSearchParams } from 'react-router-dom';
import NewsBriefingTutorial from './NewsBriefingTutorial';

export const NewsBriefingPage = () => {
  const [searchParams] = useSearchParams();
  const skipTutorial = searchParams.get('skipTutorial');
  const shouldShowTutorial = skipTutorial !== 'true'; // "false"일 때만 튜토리얼을 건너뜀

  return (
    <NewsBriefingProvider>
      {shouldShowTutorial ? <NewsBriefingTutorial /> : <NewsBriefingSwiper />}
    </NewsBriefingProvider>
  );
};
